import { useEffect, useMemo, useRef, useState } from 'react';
import { InteractionConfig } from './types';
import bg0 from './assets/bg0.svg';
import bg1 from './assets/bg1.svg';
import bg2 from './assets/bg2.svg';
import bg3 from './assets/bg3.svg';
const backgrounds = [bg0, bg1, bg2, bg3];

export default function Interaction(props: {
	shouldPlay: boolean;
	config: InteractionConfig;
	onLoaded: () => void;
	onDone: () => void;
	onError: (e: Error) => void;
}) {
	const [selIdx, setSelIdx] = useState(-1000);
	const [loadedResources, setLoadedResources] = useState(0);

	const otherResources = 2;
	const clickingAudio = useRef<HTMLAudioElement | null>();
	const winningAudio = useRef<HTMLAudioElement | null>();

	const { longList, effIdx } = useMemo(() => {
		// make it long for nicer effect
		const longList = [
			...props.config.interactions,
			...props.config.interactions,
			...props.config.interactions,
			...props.config.interactions,
			...props.config.interactions,
		];
		let effIdx = 2 * props.config.interactions.length + props.config.selectedIdx;
		// always put the result in the middle to make logic easier
		const shiftIdx = effIdx - longList.length / 2;
		//debugger;
		if (shiftIdx < 0) {
			for (let i = 0; i < -2 * shiftIdx; i++) {
				longList.unshift(longList[props.config.interactions.length - i - 1]);
				effIdx++;
			}
		} else if (shiftIdx > 0) {
			for (let i = 0; i < 2 * shiftIdx; i++) {
				longList.push(longList[props.config.interactions.length - i - 1]);
			}
		}
		// console.log('x', longList.length, effIdx, 'from', props.config.selectedIdx, props.config.interactions.length);
		return { longList, effIdx };
	}, [props.config.interactions, props.config.selectedIdx]);

	useEffect(() => {
		if (!props.shouldPlay) {
			return;
		}
		const play = async () => {
			// play clicking and play fast animation
			//TODO animation
			await playAudio(clickingAudio.current!);

			// play winning sound and show selection
			setSelIdx(effIdx);
			await playAudio(winningAudio.current!);
			await new Promise((r) => setTimeout(r, 2_500));
			props.onDone();
		};
		play();
	}, [props, effIdx]);

	useEffect(() => {
		if (loadedResources > 0 && loadedResources === otherResources + longList.length) {
			// call after preloading is done
			props.onLoaded();
		}
	}, [loadedResources, props, longList]);

	function getBlur(dist: number) {
		// we're disabling blurring for now because it looks bad
		return;
		/*
		dist = Math.abs(dist);
		if (dist > 3) {
			return 'blur-lg';
		}
		if (dist > 1) {
			return 'blur-md';
		}
		if (dist > 0) {
			return 'blur-sm';
		}
		 */
	}

	return (
		<div className="flex flex-col w-full items-center">
			<div className={`-ml-80 flex flex-row h-64 items-center transition-transform duration-300 ${props.shouldPlay && 'animate-left-right-swing'}`}>
				{longList.map((ia, i) => (
					<div key={i} className="w-64 h-64 flex items-center place-content-around">
						<div className={`m-10 ${i === selIdx ? 'bg-winning rounded-4xl p-1 animate-pulse-p' : getBlur(i - selIdx)}`}>
							<div
								className={`w-full h-full flex flex-col items-center`}
								style={{
									backgroundImage: `url('${backgrounds[i % backgrounds.length]}')`,
									backgroundSize: 'contain',
									backgroundRepeat: 'no-repeat',
								}}
							>
								<img alt={ia.Title} className="mt-4 max-w-[130px] w-full object-contain" src={ia.ImageUrl} onLoad={() => setLoadedResources((cnt) => cnt + 1)} />
								<p className="p-2 mt-4 mx-4 rounded-b-3xl w-full grow bg-black flex flex-row items-center place-content-around text-xl font-bold text-white">
									{ia.Title}
								</p>
							</div>
						</div>
					</div>
				))}
			</div>
			<audio
				src="/clicking.mp3"
				preload={'preload'}
				autoPlay={false}
				controls={false}
				onCanPlayThrough={() => setLoadedResources((cnt) => cnt + 1)}
				ref={(r) => (clickingAudio.current = r)}
			/>
			<audio
				src="/winning.mp3"
				preload={'preload'}
				autoPlay={false}
				controls={false}
				onCanPlayThrough={() => setLoadedResources((cnt) => cnt + 1)}
				ref={(r) => (winningAudio.current = r)}
			/>
		</div>
	);
}

const playAudio = async (audio: HTMLAudioElement) => {
	const done = new Promise((res, rej) => {
		audio.onended = res;
		audio.onerror = rej;
	});
	audio.play();
	await done;
};
